import type {
  Category,
  RaterXCoverage,
} from '../../../../../workflows/quotes/prime-x/api/types/rater-x-preset';
import type { QuoteFieldValue } from '../../../../../../api/quotes.api.types';

interface IUseMergeRaterXCoverages {
  coverageCategories: Category[];
  fieldValues: QuoteFieldValue[];
}
const useMergeRaterXCoverages = ({
  coverageCategories,
  fieldValues,
}: IUseMergeRaterXCoverages) => {
  const coverageMap: Record<string, QuoteFieldValue> =
    fieldValues?.reduce((_coverageMap, coverage) => {
      return {
        ..._coverageMap,
        [coverage.fieldId]: coverage,
      };
    }, {}) ?? {};

  const mergeFieldValues = (coverage: RaterXCoverage): RaterXCoverage => {
    if (!coverage?.field?.id) {
      return coverage;
    }
    const merged = {
      ...coverage,
      isSelected: coverage.field.id in coverageMap,
      value: coverageMap[coverage.field.id]?.value,
    };
    if (coverage.children?.length) {
      merged.children = coverage.children.map(mergeFieldValues);
    }
    return merged;
  };

  return {
    coverageCategories: coverageCategories.map((_category) => ({
      ..._category,
      groups: _category?.groups.map((_group) => ({
        ..._group,
        coverages: _group?.coverages.map(mergeFieldValues),
      })),
    })),
  };
};

export default useMergeRaterXCoverages;
